import { render, staticRenderFns } from "./CodeBlockPanel.vue?vue&type=template&id=6b76fbdb&scoped=true&"
import script from "./CodeBlockPanel.vue?vue&type=script&lang=js&"
export * from "./CodeBlockPanel.vue?vue&type=script&lang=js&"
import style0 from "./CodeBlockPanel.vue?vue&type=style&index=0&id=6b76fbdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b76fbdb",
  null
  
)

export default component.exports